// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__lLT6d","errors":"Errors_errors__3OVz5"};